import React from 'react';

import { IndexTable } from "Components/Utilities";
import { BooleanFilter, DateTimeFilter, IsEmptyFilter } from "Components/Filters";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "Components/Modal";
import { DangerButton, PrimaryButton } from "Components/Button";

import AdminLayout from 'Pages/Admin/AdminLayout';

import AdminUsersApi from "Services/Api/Admin/Users";
import Toast from "Services/Toast";

class Archive extends React.Component {
    /**
     * @var columns
     * @type {array}
     */
    columns = [
        {
            label: 'First Name',
            value: 'first_name',
            type: 'string',
            orderable: 'first_name'
        },
        {
            label: 'Last Name',
            value: 'last_name',
            type: 'string',
            orderable: 'last_name'
        },
        {
            label: 'Email',
            value: 'email',
            type: 'string',
            orderable: 'email'
        },
        {
            label: 'Username',
            value: 'username',
            type: 'string',
            orderable: 'username',
            filters: [
                {
                    column: 'username',
                    label: 'Username',
                    component: IsEmptyFilter
                }
            ]
        },
        {
            label: 'Subscription',
            value: 'active_cashier_subscription_name',
            type: 'string',
            orderable: null,
            feature: 'subscriptions'
        },
        {
            label: 'Group',
            value: (record) => record.groups?.map((group, i) => (
                <>
                    {group.name}{i !== (record.groups.length - 1) ? ', ' : null}
                </>
            )),
            type: 'callback',
            orderable: null,
            feature: 'groups'
        },
        {
            label: 'Admin',
            value: 'is_admin',
            type: 'boolean',
            orderable: 'is_admin',
            filters: [
                {
                    column: 'is_admin',
                    label: 'Admin',
                    component: BooleanFilter
                }
            ]
        },
        {
            label: 'Colour',
            value: (user) => (
                <div
                    className="w-10 h-10 border"
                    style={{backgroundColor: user.colour}}
                />
            ),
            type: 'callback',
            orderable: null,
            valueClassName: 'text-center'
        },
        {
            label: 'Created At',
            value: 'created_at',
            type: 'datetime',
            orderable: 'created_at',
            hideByDefault: true,
            filters: [
                {
                    column: 'created_at',
                    label: 'Created At Before',
                    component: DateTimeFilter,
                    props: {
                        type: 'datetime',
                        direction: 'before'
                    }
                },
                {
                    column: 'created_at',
                    label: 'Created At After',
                    component: DateTimeFilter,
                    props: {
                        type: 'datetime',
                        direction: 'after'
                    },
                },
            ],
        }
    ];

    /**
     * @method getRowActions
     * @param item
     * @returns {[{component: {contextType?: React.Context<any>, new<P, S>(props: Readonly<P>): {state: {initialValues, form: {}, alert: null, working: boolean}, handleSetInitialValues: function(Object): void, handleSetForm: function(Object, boolean=): (void), working: function(boolean=): void, handleSubmit: function(Event, Function=, (string|Function|null)=, boolean=): Promise<void>, handleInput: function(string, string): void, handleResetForm: function(): void, handleAlert: function(string, string, string[]): void, handleResetAlert: function(): void, getFieldError: function(string): (Array|null), render: {(): *, (): React.ReactNode}, componentDidMount?(): void, shouldComponentUpdate?(nextProps: Readonly<{}>, nextState: Readonly<{}>, nextContext: any): boolean, componentWillUnmount?(): void, componentDidCatch?(error: Error, errorInfo: React.ErrorInfo): void, getSnapshotBeforeUpdate?(prevProps: Readonly<{}>, prevState: Readonly<{}>): any, componentDidUpdate?(prevProps: Readonly<{}>, prevState: Readonly<{}>, snapshot?: any): void, componentWillMount?(): void, UNSAFE_componentWillMount?(): void, componentWillReceiveProps?(nextProps: Readonly<{}>, nextContext: any): void, UNSAFE_componentWillReceiveProps?(nextProps: Readonly<{}>, nextContext: any): void, componentWillUpdate?(nextProps: Readonly<{}>, nextState: Readonly<{}>, nextContext: any): void, UNSAFE_componentWillUpdate?(nextProps: Readonly<{}>, nextState: Readonly<{}>, nextContext: any): void, context: any, setState<K extends keyof S>(state: (((prevState: Readonly<S>, props: Readonly<P>) => (Pick<S, K> | S | null)) | Pick<S, K> | S | null), callback?: () => void): void, forceUpdate(callback?: () => void): void, readonly props: Readonly<P> & Readonly<{children?: React.ReactNode}>, refs: {[p: string]: React.ReactInstance}}, new<P, S>(props: P, context?: any): {state: {initialValues, form: {}, alert: null, working: boolean}, handleSetInitialValues: function(Object): void, handleSetForm: function(Object, boolean=): (void), working: function(boolean=): void, handleSubmit: function(Event, Function=, (string|Function|null)=, boolean=): Promise<void>, handleInput: function(string, string): void, handleResetForm: function(): void, handleAlert: function(string, string, string[]): void, handleResetAlert: function(): void, getFieldError: function(string): (Array|null), render: {(): *, (): React.ReactNode}, componentDidMount?(): void, shouldComponentUpdate?(nextProps: Readonly<{}>, nextState: Readonly<{}>, nextContext: any): boolean, componentWillUnmount?(): void, componentDidCatch?(error: Error, errorInfo: React.ErrorInfo): void, getSnapshotBeforeUpdate?(prevProps: Readonly<{}>, prevState: Readonly<{}>): any, componentDidUpdate?(prevProps: Readonly<{}>, prevState: Readonly<{}>, snapshot?: any): void, componentWillMount?(): void, UNSAFE_componentWillMount?(): void, componentWillReceiveProps?(nextProps: Readonly<{}>, nextContext: any): void, UNSAFE_componentWillReceiveProps?(nextProps: Readonly<{}>, nextContext: any): void, componentWillUpdate?(nextProps: Readonly<{}>, nextState: Readonly<{}>, nextContext: any): void, UNSAFE_componentWillUpdate?(nextProps: Readonly<{}>, nextState: Readonly<{}>, nextContext: any): void, context: any, setState<K extends keyof S>(state: (((prevState: Readonly<S>, props: Readonly<P>) => (Pick<S, K> | S | null)) | Pick<S, K> | S | null), callback?: () => void): void, forceUpdate(callback?: () => void): void, readonly props: Readonly<P> & Readonly<{children?: React.ReactNode}>, refs: {[p: string]: React.ReactInstance}}, prototype: {state: {initialValues, form: {}, alert: null, working: boolean}, handleSetInitialValues: function(Object): void, handleSetForm: function(Object, boolean=): (void), working: function(boolean=): void, handleSubmit: function(Event, Function=, (string|Function|null)=, boolean=): Promise<void>, handleInput: function(string, string): void, handleResetForm: function(): void, handleAlert: function(string, string, string[]): void, handleResetAlert: function(): void, getFieldError: function(string): (Array|null), render: {(): *, (): React.ReactNode}, componentDidMount?(): void, shouldComponentUpdate?(nextProps: Readonly<{}>, nextState: Readonly<{}>, nextContext: any): boolean, componentWillUnmount?(): void, componentDidCatch?(error: Error, errorInfo: React.ErrorInfo): void, getSnapshotBeforeUpdate?(prevProps: Readonly<{}>, prevState: Readonly<{}>): any, componentDidUpdate?(prevProps: Readonly<{}>, prevState: Readonly<{}>, snapshot?: any): void, componentWillMount?(): void, UNSAFE_componentWillMount?(): void, componentWillReceiveProps?(nextProps: Readonly<{}>, nextContext: any): void, UNSAFE_componentWillReceiveProps?(nextProps: Readonly<{}>, nextContext: any): void, componentWillUpdate?(nextProps: Readonly<{}>, nextState: Readonly<{}>, nextContext: any): void, UNSAFE_componentWillUpdate?(nextProps: Readonly<{}>, nextState: Readonly<{}>, nextContext: any): void, context: any, setState<K extends keyof S>(state: (((prevState: Readonly<S>, props: Readonly<P>) => (Pick<S, K> | S | null)) | Pick<S, K> | S | null), callback?: () => void): void, forceUpdate(callback?: () => void): void, readonly props: Readonly<P> & Readonly<{children?: React.ReactNode}>, refs: {[p: string]: React.ReactInstance}}}, text: string, type: string, props: {userId: *}}]}
     */
    getRowActions = (item) => {
        return [
            {
                type: "modalTrigger",
                component: RestoreUser,
                props: {
                    userId: item?.id,
                },
                text: 'Restore'
            }
        ];
    };

    render () {
        return (
            <AdminLayout title="Archive">
                <IndexTable
                    columns={this.columns}
                    defaultOrder={{
                        order_by: 'first_name',
                        order: 'asc'
                    }}
                    displaySearchBar={true}
                    loadDataCallback={(data) => AdminUsersApi.get(null, {
                        ...data,
                        is_archive: true,
                    })}
                    rowActions={this.getRowActions}
                    eventApi={AdminUsersApi}
                />
            </AdminLayout>
        );
    }
};

const RestoreUser = ({ onClose, userId }) => {
    const archive = async () => {
        const { success } = await AdminUsersApi.archiveToggle(userId, false);

        if (success) {
            Toast.success("User restored successfully");
            onClose();
        }
    };

    return (
        <Modal>
            <ModalHeader>
                Restore User
            </ModalHeader>

            <ModalBody>
                <p>Are you sure you want to restore this user?</p>
            </ModalBody>

            <ModalFooter>
                <div className="flex justify-center space-x-4 items-center w-full">
                    <PrimaryButton
                        onClick={onClose}
                        text="Cancel"
                    />

                    <DangerButton
                        onClick={archive}
                        text="Restore"
                    />
                </div>
            </ModalFooter>
        </Modal>
    );
};

export default Archive;
